import React, { useEffect, useState } from 'react';

import { TmAddress } from '@/tscapi/model/account';

import { FormAddress } from './FormAddress';

interface EditAddressProps {
    selectedAddress?: TmAddress;
    selectedAddressId?: number;
    selectedAddressType?: string;
}
export const EditAddress = (props: EditAddressProps) => {
    const { selectedAddress, selectedAddressType } = props;
    const [addressErrorMessage, setAddressErrorMessage] = useState('');
    useEffect(() => {}, []);

    return (
        <>
            {addressErrorMessage && (
                <div className="notification__red">
                    <img
                        src="/App_Assets/public/icon-exclamation-black.svg"
                        alt="exclamation-icon"
                        className="exclamation-img"
                    />
                    <div>
                        <strong>{addressErrorMessage}</strong>
                    </div>
                </div>
            )}
            <div>
                <FormAddress
                    selectedAddress={selectedAddress}
                    setFormError={setAddressErrorMessage}
                    selectedAddressType={selectedAddressType}
                ></FormAddress>
            </div>
        </>
    );
};
